import './pt-relay-control.css';
import CLICK_CONTEXTMENU from '../../mixins/CLICK_CONTEXTMENU';
import MOUSE_ENTER_LEAVE from '../../mixins/MOUSE_ENTER_LEAVE';

export default {
	mixins: [CLICK_CONTEXTMENU, MOUSE_ENTER_LEAVE],
	model: {
		'value': {
			type: 'boolean',
			default: false,
			bind: {
				to: 'attr',
				name: 'data-value'
			}
		}
	}
};
